import { useTranslation } from 'react-i18next'

import { z } from '@/lib/zod'

export function NewsHighlightedContentSchema() {
  const { t } = useTranslation()

  return z.object({
    content: z.string().optional(),
    image: z.instanceof(File, { message: t('zod:errors.invalid_type') }),
  })
}

export type NewsHighlightedContentForm = z.infer<
  ReturnType<typeof NewsHighlightedContentSchema>
>
